import {resolveBackground} from '#core/utils/color-utils.js';

export function staticPagesFactory(PALETTE) {
    const {FONT} = PALETTE;

    return {
        StaticHtmlPage: {
            container: {
                ...resolveBackground(PALETTE.STATIC_PAGE_BG),
            },
            textView: {
                header: {
                    textStyle: {
                        fontSize: FONT.SIZE_XLARGE,
                        ...PALETTE.STATIC_PAGE_HEADER_TEXT,
                    },
                    borderStyle: {
                        borderColor: PALETTE.STATIC_PAGE_SEPARATOR_COLOR,
                    },
                },
                textArea: {
                    textStyle: {
                        fontSize: FONT.SIZE_MEDIUM,
                        ...PALETTE.STATIC_PAGE_TEXT,
                    },
                },
            },
        },
    };
}
